import Vue from 'vue'
import { Message } from 'element-ui'
import Router from 'vue-router'
import store from '@/plugins/store'

import BaseLayout from '@/components/layout/base'

import {routers as baseRouters, routersNames as baseRoutersNames} from '@/plugins/router/base'
import {routers as unauthorityRouters, routersNames as unauthorityRoutersNames} from '@/plugins/router/unauthority'
import authorityRouters from '@/plugins/router/authority'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: BaseLayout,
      children: [
        ...unauthorityRouters,
        ...authorityRouters
      ]
    },
    ...baseRouters
  ]
})

const unpowerRouters = baseRoutersNames.concat(unauthorityRoutersNames)

router.beforeEach((to, from, next) => {
  to.meta.hasOwnProperty('title') && (document.title = to.meta.title)
  if (!unpowerRouters.includes(to.name)) {
    if (store.getters.isUser) {
      store.dispatch('setRouters', authorityRouters).then(() => {
        const route = store.getters.menus
        if (to.name === 'home') {
          if (route.length > 0) {
            next(route[0])
          } else {
            Message.error('账号未被授权')
            next(false)
          }
        } else if (unpowerRouters.includes(to.name) || store.getters.routers.includes(to.matched[to.matched.length - 1].path)) {
          next()
        } else {
          next()
          // Message.error('账号未被授权')
          // next(false)
        }
      })
    } else if (window.localStorage.getItem('____p__u__ing__')) {
      store.dispatch('autoLogin').then(r => {
        if (r) {
          store.dispatch('setRouters', authorityRouters).then(() => {
            const route = store.getters.menus
            if (to.name === 'home') {
              if (route.length > 0) {
                next(route[0])
              } else {
                Message.error('账号未被授权')
                next({name: 'login'})
              }
            } else if (unpowerRouters.includes(to.name) || store.getters.routers.includes(to.path)) {
              next()
            } else {
              next()
              // Message.error('账号未被授权')
              // next({name: 'login'})
            }
          })
        } else {
          next({name: 'login'})
        }
      })
    } else {
      next({name: 'login'})
    }
  } else {
    next()
  }
})

export default router
